/*
 * @providesModule StayInLoopStyle
 */

import {StyleSheet, Dimensions, Platform} from 'react-native';
import Sizes from 'Sizes';

const backgroundWidth = Dimensions.get('screen').width * 1.3;
const backgroundHeightDivider = Sizes.isTablet() ? 3.78 : Platform.OS == 'ios' ? 3.2 : 2.45;
const buttonWidth = Sizes.isTablet() ? 374 : 311;
const regularFontSize = Sizes.isTablet() ? 19 : 16;
const regularLineHeight = Sizes.isTablet() ? 28 : 20;
const largeFontSize = Sizes.isTablet() ? 24 : 20;
let backgroundHeight = Dimensions.get('screen').height / backgroundHeightDivider;
if (backgroundHeight < 250) {
  backgroundHeight = 256;
}

export default StyleSheet.create({
  headerContainer: {
    width: '100%',
    borderBottomColor: 'rgba(0, 0, 0, 0.2)',
    borderBottomWidth: 1,
    justifyContent: 'center',
  },

  background: {
    width: backgroundWidth,
    height: backgroundHeight,
    alignSelf: 'center',
    position: 'absolute',
    marginTop: 0,
  },

  saveAccountContainer: {
    alignSelf: 'center',
    marginLeft: Sizes.isTablet() ? -25 : -18,
    flexDirection: 'row',
    marginTop: Sizes.isTablet() ? 20 : 16,
  },

  saveAccountHeadersContainer: {
    justifyContent: 'center',
    marginLeft: Sizes.isTablet() ? 25 : 18,
    alignItems: 'center',
  },

  subHeaderText: {
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    fontSize: Sizes.isTablet() ? 20 : 18,
    color: 'rgba(0, 0, 0, 0.9)',
    marginBottom: 22,
  },

  subBodyText: {
    alignSelf: 'center',
    width: 311,
    alignContent: 'center',
    textAlign: 'center',
    fontFamily: 'OpenSans',
    fontSize: Sizes.isTablet() ? 18 : 16,
    color: 'rgba(0, 0, 0, 0.9)',
  },

  orText: {
    fontSize: Sizes.isTablet() ? 14 : 12,
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    color: '#757575',
    right: 4,
  },

  loginText: {
    lineHeight: regularLineHeight,
    fontSize: regularFontSize,
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    color: '#ffffff',
  },

  skillzSignUpText: {
    fontSize: regularFontSize,
    lineHeight: regularLineHeight,
    fontStyle: 'normal',
    alignSelf: 'center',
    fontFamily: 'OpenSans-SemiBold',
    color: 'rgba(0, 0, 0, 0.9)',
  },

  skillzSignUpTextContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    marginTop: Sizes.isTablet() ? 19 : 20,
    marginBottom: Sizes.isTablet() ? 1 : 0,
  },

  container: {
    alignItems: 'center',
    backgroundColor: '#ffffff',
    height: '100%',
    ...Platform.select({
      web: {
        width: '100%',
      },
    }),
  },

  containerScrollview: {
    backgroundColor: '#ffffff',
    width: '100%',
    height: '100%',
  },

  inputView: {
    marginTop: 16,
    marginBottom: Sizes.isTablet() ? 4 : 0,
    height: Sizes.isTablet() ? 77 : 62,
    width: buttonWidth,
    flexDirection: 'row',
    alignSelf: 'center',
    backgroundColor: '#ffffff',
    borderRadius: 9,
  },

  socialLoginContainer: {
    marginVertical: 10,
  },

  fedDivider: {
    alignSelf: 'center',
    borderBottomColor: '#000000',
    borderBottomWidth: 1,
    opacity: 0.4,
    width: Sizes.isTablet() ? 168 : 138,
    marginEnd: 8,
  },

  fedLoginText: {
    fontSize: regularFontSize,
    lineHeight: regularLineHeight,
    fontFamily: 'OpenSans-SemiBold',
    color: 'rgba(0,0,0,.9)',
    alignSelf: 'center',
  },

  fedLoginBtn: {
    width: buttonWidth,
    height: Sizes.isTablet() ? 58 : 48,
    borderColor: 'rgba(0, 0, 0, 0.4)',
    backgroundColor: '#FFFFFF',
    borderWidth: 1,
    borderRadius: 100,
    flexDirection: 'row',
    alignSelf: 'center',
    marginVertical: 8,
  },

  fedLoginBtnContainer: {
    flex: 1,
    marginTop: 16,
    maxHeight: Sizes.isTablet() ? 214 : 176,
    marginBottom: Sizes.isTablet() ? 20 : 16,
    justifyContent: 'space-between',
  },
  buttonContainer: {
    width: buttonWidth,
    borderRadius: Sizes.isTablet() ? 29 : 24,
    height: Sizes.isTablet() ? 58 : 48,
    marginBottom: Sizes.isTablet() ? 32 : 16,
    marginTop: 24,
    justifyContent: 'center',
    alignSelf: 'center',
    backgroundColor: '#4890E8',
  },

  socialIcons: {
    height: Sizes.isTablet() ? 30 : 24,
    width: Sizes.isTablet() ? 30 : 24,
    marginLeft: 12,
    marginRight: Sizes.isTablet() ? 45 : 40.5,
    marginTop: Sizes.isTablet() ? 14 : 12,
    justifyContent: 'flex-start',
  },

  textInInput: {
    left: 12,
    fontSize: 16,
    fontFamily: 'OpenSans-Regular',
  },

  orContainer: {
    flexDirection: 'row',
    height: Sizes.isTablet() ? 20 : 16,
    marginTop: 24,
    alignSelf: 'center',
    justifyContent: 'center',
    marginBottom: 10,
    width: '100%',
  },

  errorMessage: {
    fontSize: Sizes.isTablet() ? 14 : 12,
    color: 'rgba(221, 105, 82, 1)',
    fontFamily: 'OpenSans-SemiBold',
    marginLeft: Sizes.isTablet() ? 5.5 : 5.33,
  },

  errorContainer: {
    flexDirection: 'row',
    width: buttonWidth,
    marginTop: 4,
    alignSelf: 'center',
  },

  rightIcon: {
    height: 23,
    width: 23,
  },

  errorIcon: {
    height: 16,
    width: 16,
  },

  keyboardAvoidContainer: {
    flex: 1,
    width: Dimensions.get('screen').width,
  },

  textContainer: {
    marginHorizontal: Sizes.isTablet() ? 230 : 62,
    marginTop: Sizes.isTablet() ? 59 : 56,
    marginBottom: Sizes.isTablet() ? 20 : 16,
  },

  rowContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  headerText: {
    fontFamily: 'OpenSans-Bold',
    fontSize: largeFontSize,
    lineHeight: Sizes.isTablet() ? 34 : 28,
    color: '#000000',
  },

  descriptionText: {
    width: Sizes.isTablet() ? 369 : 311,
    fontFamily: 'OpenSans-Regular',
    fontSize: regularFontSize,
    alignSelf: 'center',
    lineHeight: Sizes.isTablet() ? 26 : 22,
    marginTop: Sizes.isTablet() ? 16 : 8,
    color: '#000000E5',
  },

  checkIcon: {
    height: largeFontSize,
    width: largeFontSize,
  },
});
